export default __webpack_public_path__ + "static/media/image-room-meeting.08843343.jpg";